<a [routerLink]="[ isSold ? '/project/sold' :'/project', project.id]" class="c-project" *ngIf="project">
  <div class="c-project__container">
    <img [src]="project.picturesUrl " class="c-project__image" />
    <div class="c-project__title">
      <p> {{ project.reference }} | {{ project.city }}</p>
    </div>
  </div>
</a>